module.exports = __webpack_public_path__ + "AvenirNext-Medium.3885c0cebfbc3e55fbe3.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Venkat Projects/sagiam-tool-angular/src/assets/fonts/AvenirNext-Medium.ttf
// module id = ../../../../../src/assets/fonts/AvenirNext-Medium.ttf
// module chunks = styles